<script lang="ts">
	import MetaHead from '$lib/components/MetaHead.svelte';

	let { data } = $props();
</script>

<MetaHead {data} />

<section class="mx-auto mt-24 max-w-4xl rounded-md bg-foreground/10 p-6 leading-relaxed shadow-md">
	<h1 class="mb-6 text-3xl font-bold">Politique de Confidentialité</h1>
	<p class="mb-8 text-sm text-gray-500">Dernière mise à jour : 1 février 2026</p>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">1. Introduction</h2>
		<p>
			La protection de vos données personnelles est une priorité pour <strong
				>https://www.juslin.dev/</strong
			>. Cette politique de confidentialité vous informe sur la manière dont nous collectons,
			utilisons et protégeons vos informations lorsque vous utilisez notre site.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">2. Collecte des données</h2>
		<p>Nous collectons des informations lorsque :</p>
		<ul class="mt-2 ml-6 list-disc space-y-1">
			<li>Vous vous inscrivez à notre newsletter (adresse e-mail).</li>
			<li>Vous nous contactez via le formulaire de contact ou pour une demande d'audit.</li>
			<li>Vous naviguez sur le site (données analytiques anonymes via des cookies).</li>
		</ul>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">3. Utilisation des données</h2>
		<p>Les informations que nous recueillons sont utilisées pour :</p>
		<ul class="mt-2 ml-6 list-disc space-y-1">
			<li>Personnaliser votre expérience et répondre à vos besoins individuels.</li>
			<li>Améliorer notre site web et nos services.</li>
			<li>Vous envoyer des e-mails périodiques (newsletter, réponses à vos demandes).</li>
		</ul>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">4. Protection et Partage des données</h2>
		<p>
			Vos données personnelles ne sont ni vendues, ni échangées, ni transférées à des tiers. Cela
			n'inclut pas les tierces parties de confiance qui nous aident à exploiter notre site web
			(comme notre hébergeur Vercel), tant que ces parties conviennent de garder ces informations
			confidentielles.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">5. Cookies</h2>
		<p>
			Nous utilisons des cookies pour améliorer l'accès à notre site et identifier les visiteurs
			réguliers. Cependant, cette utilisation des cookies n'est en aucune façon liée à des
			informations personnelles identifiables sur notre site.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">6. Vos droits</h2>
		<p>
			Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de portabilité et de
			suppression de vos données. Vous pouvez exercer ces droits en nous contactant via les réseaux
			sociaux ou par le formulaire de contact disponible sur le site.
		</p>
	</section>

	<footer class="mt-12 border-t border-gray-200 pt-6">
		<a href="/" class="text-blue-600 hover:underline">← Retour à l'accueil</a>
	</footer>
</section>
